"use client";

import { Progress } from "@speakai/ui/progress";
import { useTranslation } from "react-i18next";
import type { S3UploadProgress } from "../../s3-upload";

interface UploadProgressProps {
  progress: S3UploadProgress | null;
}

export function UploadProgress({ progress }: UploadProgressProps) {
  const { t } = useTranslation();
  const percent = progress?.percent ?? 0;

  return (
    <div
      className="flex flex-col gap-1.5"
      role="status"
      aria-live="polite"
      aria-label={t(
        "RECORD.UPLOAD_PROGRESS_ARIA",
        "Upload {{percent}} percent complete",
        { percent: Math.round(percent) },
      )}
    >
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{t("RECORD.UPLOADING", "Uploading recording…")}</span>
        <span>{Math.round(percent)}%</span>
      </div>
      <Progress value={percent} className="h-1.5" />
    </div>
  );
}
